import React, { Component } from "react";
import axios from "axios";
import ReactTable from "react-table";
import swal from "sweetalert";
import md5 from "md5";
import sha256 from "crypto-js/sha256";
import HmacSHA256 from "crypto-js/hmac-sha256";

axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Content-Type";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

class Gjurmim extends Component {
  state = {
    nrKodi: "",
    posts: [],
    Token: "",
    username: "",
    time: "",
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  onClearInput = () => {
    this.setState({
      nrKodi: "",
      posts: [],
    });
  };
  handleClick = (e) => {
    var d = new Date();

    const data = {
      nrKodi: this.state.nrKodi,

       Token: HmacSHA256(
         Math.round(new Date().getTime() / 1000).toString(),
         window.UserP.key
      ).toString(),

       username: window.UserP.username,
    };
    if (this.state.nrKodi === "") {
      swal("Ju lutem vendosni numrin e podit!");
    } else {
      //   console.log("token", offset);

      // const headers = {
      //   Accept: "application/json",
      //   "Content-type": "application/json",
      //   "Access-Control-Allow-Origin": "*",
      // };

      axios.post(window.UserP.url + "POD/Gjurmo", data).then((response) => {
        this.setState({ posts: response.data });
      });
     
    }
  };


  
  render() {
    const columns = [
      {
        Header: "Kodi",
        accessor: "koditem",
      },
      {
        Header: "Data",
        accessor: "data",
        //.toLocaleDateString("en-US").substring(1, 4)
        Cell: (row) => {
          return <div>{row.value.substring(8, 10)+"/"+row.value.substring(5, 7)+"/"+row.value.substring(0, 4)+"   "+row.value.substring(11, 13)+":"+row.value.substring(14, 16)+":"+row.value.substring(17, 19)}</div>;
        },
      },

  
      {
        Header: "Agjensia",
        accessor: "AgjEmriBurim",
      },

      {
        Header: "Operatori",
        accessor: "Operatori"
      },

      {
        Header: "Veprimi",
        accessor: "Veprimi",
      },
      {
        Header: "Canta",
        accessor: "CantaItemKod",
        Cell: (row) => (
          <div>
            <span title={row.value}>{row.value}</span>
          </div>
        ),
      },
    ];
    return (
      <div className="Form">
        <div className="card card-body bg-light col-md-4">
          <label className="">Nr. POD</label>
          <input
            id="nrKodi"
            name="nrKodi"
            value={this.state.nrKodi}
            className="form-control "
            type="text"
            onChange={(e) => this.handleInputChange(e, "nrKodi")}
          />
        </div>
      <div className="row ml-2">
        <button className="btn btn-primary " onClick={this.handleClick}>
          <span data-notify="icon" className="pe-7s-search" />
          &nbsp; Kerko
        </button>

        <button className="btn btn-primary ml-4" onClick={this.onClearInput}>
          <span data-notify="icon" className="pe-7s-trash" />
          &nbsp; Pastro
        </button>
        </div>
        <div className="card card-body bg-light col-md-12 mt-4">
          <ReactTable
            columns={columns}
            data={this.state.posts}
            defaultPageSize={5}
            className="-striped -highlight mt-4"
            pageText="Faqe"
            nextText="Para"
            rowsText="Rreshta"
            previousText="Mbrapa"
            noDataText="Nuk ka te dhena"
          />
        </div>
      </div>
    );
  }
}

export default Gjurmim;
